// src/wizard/WizardChoice.jsx
import { useCallback } from "react";

const brand = { green: "#00B074", gold: "#F4C542" };

export default function WizardChoice({ onManual, onAuto }) {
  return (
    <div style={{ maxWidth: 720, margin: "2rem auto", padding: "1.5rem" }}>
      <h1 style={{ marginBottom: "0.5rem" }}>Let’s set up your budget</h1>
      <p style={{ color: "#555", marginBottom: "1.25rem" }}>
        Build it yourself or let Trelli analyze your spending and goals.
      </p>

      <div style={{ display: "grid", gap: "1rem" }}>
        <button
          onClick={onManual}
          style={{
            padding: "0.85rem 1rem",
            borderRadius: 10,
            border: "1px solid #ddd",
            background: "#fff",
            fontWeight: 600,
            textAlign: "left",
            cursor: "pointer"
          }}
        >
          I’ll create my own (manual)
          <div style={{ fontWeight: 400, color: "#666" }}>
            Opens the Budget Builder you already have.
          </div>
        </button>

        <button
          onClick={onAuto}
          style={{
            padding: "0.85rem 1rem",
            borderRadius: 10,
            border: "none",
            background: brand.green,
            color: "white",
            fontWeight: 700,
            textAlign: "left",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
          }}
        >
          Trelli, build it for me
          <div style={{ fontWeight: 400, color: "white", opacity: 0.9 }}>
            We’ll connect accounts or upload transactions, confirm matches, and suggest a budget.
          </div>
        </button>
      </div>
    </div>
  );
}